import { Box, Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { CompanyDetailsDetailsModel } from "@store/ai-o/companies/details";

import { Colors } from "@constants/colors.constant";

import EditSocialMediaModal from "@screens/auth/admin/aio/customerDetails/profileBlocks/EditSocialMedia.modal";

interface SocialMediaBlockProps {
  company: CompanyDetailsDetailsModel;
}

const SocialMediaBlock = (props: SocialMediaBlockProps) => {
  const { company } = props;

  const { t } = useTranslation();

  const [openEdit, setOpenEdit] = useState(false);

  return (
    <Stack position="relative" width="100%">
      <Stack width="100%" p="25px" bgcolor={Colors.background} borderRadius="15px" spacing="10px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="calc(100% + 10px)">
          <Typography fontSize={16} fontWeight="700">
            {t("aio.clients.details.socialMedia.title")}
          </Typography>
          <Box sx={{"& > .MuiButton-root": { padding: "5px 10px" }}}>
            <Button variant="text" color="primary" onClick={() => setOpenEdit(true)}>
              {t("global.modify")}
            </Button>
          </Box>
        </Stack>
        <Stack spacing="20px">
          <Stack>
            <Typography fontSize="14px" fontWeight="500">
              {t("aio.clients.details.socialMedia.linkedin")}
            </Typography>
            <Typography fontSize="14px" fontWeight="300" color={Colors.greyLight}>
              {company.linkedin || "-"}
            </Typography>
          </Stack>
          <Stack>
            <Typography fontSize="14px" fontWeight="500">
              {t("aio.clients.details.socialMedia.instagram")}
            </Typography>
            <Typography fontSize="14px" fontWeight="300" color={Colors.greyLight}>
              {company.instagram || "-"}
            </Typography>
          </Stack>
          <Stack>
            <Typography fontSize="14px" fontWeight="500">
              {t("aio.clients.details.socialMedia.youtube")}
            </Typography>
            <Typography fontSize="14px" fontWeight="300" color={Colors.greyLight}>
              {company.youtube || "-"}
            </Typography>
          </Stack>
          <Stack>
            <Typography fontSize="14px" fontWeight="500">
              {t("aio.clients.details.socialMedia.twitter")}
            </Typography>
            <Typography fontSize="14px" fontWeight="300" color={Colors.greyLight}>
              {company.twitter || "-"}
            </Typography>
          </Stack>
          <Stack>
            <Typography fontSize="14px" fontWeight="500">
              {t("aio.clients.details.socialMedia.facebook")}
            </Typography>
            <Typography fontSize="14px" fontWeight="300" color={Colors.greyLight}>
              {company.facebook || "-"}
            </Typography>
          </Stack>
          <Stack>
            <Typography fontSize="14px" fontWeight="500">
              {t("aio.clients.details.socialMedia.tiktok")}
            </Typography>
            <Typography fontSize="14px" fontWeight="300" color={Colors.greyLight}>
              {company.tiktok || "-"}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      {openEdit && <EditSocialMediaModal company={company} handleClose={() => setOpenEdit(false)}/>}
    </Stack>
  );
};

export default SocialMediaBlock;
